import CloseIcon from "@mui/icons-material/Close";
import PublicAssessmentResults from "../../pages/PublicAssessmentResults";
import { t } from "i18next";
import { CGI_RED } from "../../helpers/enums";
import { Box, Divider, IconButton, Modal, Typography } from "@mui/material";

export default function DetailedDataModal({ open, setOpen, language, data }) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    width: 0.9,
    maxHeight: "90vh",
    overflowY: "scroll",
    borderRadius: 5,
    boxShadow: 24,
    p: 4,
  };

  return (
    <div>
      <Modal open={open} onClose={() => setOpen(false)} disableAutoFocus={true}>
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{ userSelect: "none", fontSize: 18, fontWeight: 500 }}
              >
                {t("detailedData-")}
                {data.customerMail}
              </Typography>
              <IconButton onClick={() => setOpen(false)}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Divider sx={{ my: 2, color: CGI_RED, borderBottom: 2 }} />
            <PublicAssessmentResults
              evaluationData={data.evaluationData}
              exit={() => {}}
              showExit={false}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
